import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Minus, Plus, Receipt } from "lucide-react";

const fmtData = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "");
const selectCls = "w-full h-10 rounded-md border border-input bg-background px-3 text-sm";

// Quantità, prezzo (dall'ultimo DDT/fattura) e destinazione del carico
export const CaricoRapido = ({ value, onChange, codice, nome, unita, cantieri }) => {
  const [ultimo, setUltimo] = useState(null);
  const set = (patch) => onChange({ ...value, ...patch });
  const n = Number(String(value.qty).replace(",", ".")) || 0;

  useEffect(() => {
    setUltimo(null);
    if (!codice && !nome) return;
    let live = true;
    api.get("/magazzino/ultimo-prezzo", { params: { codice, nome } })
      .then(({ data }) => { if (live && data.trovato) { setUltimo(data); onChange((v) => ({ ...v, prezzo: String(data.prezzo) })); } })
      .catch(() => {});
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codice, nome]);

  return (
    <div className="space-y-3 rounded-md border border-border p-3" data-testid="carico-rapido">
      <div>
        <Label>Quantità da caricare{unita ? ` (${unita})` : ""}</Label>
        <div className="flex items-center gap-2">
          <Button type="button" variant="outline" size="icon" className="h-11 w-11" onClick={() => set({ qty: String(Math.max(0, n - 1)) })} data-testid="assoc-qty-minus"><Minus className="h-4 w-4" /></Button>
          <Input data-testid="assoc-qty" type="number" inputMode="decimal" min="0" step="any" value={value.qty} onChange={(e) => set({ qty: e.target.value })} className="h-11 text-center text-lg font-bold" />
          <Button type="button" variant="outline" size="icon" className="h-11 w-11" onClick={() => set({ qty: String(n + 1) })} data-testid="assoc-qty-plus"><Plus className="h-4 w-4" /></Button>
        </div>
        <div className="text-[11px] text-muted-foreground mt-1">Metti 0 per associare il codice senza caricare.</div>
      </div>
      <div>
        <Label>Prezzo unitario €</Label>
        <Input data-testid="assoc-prezzo" type="number" inputMode="decimal" step="0.01" min="0" value={value.prezzo} onChange={(e) => set({ prezzo: e.target.value })} className="h-10" />
        {ultimo ? (
          <div className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1" data-testid="assoc-ultimo-prezzo">
            <Receipt className="h-3 w-3 text-primary" /> Ultimo prezzo pagato: {ultimo.documento} del {fmtData(ultimo.data)}{ultimo.fornitore ? ` · ${ultimo.fornitore}` : ""}
          </div>
        ) : (
          <div className="text-[11px] text-muted-foreground mt-1" data-testid="assoc-nessun-prezzo">Nessun prezzo trovato in fatture o DDT.</div>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <div>
          <Label>Destinazione</Label>
          <select data-testid="assoc-ubicazione" value={value.ubicazione} onChange={(e) => set({ ubicazione: e.target.value, cantiere_id: e.target.value === "cantiere" ? value.cantiere_id : "" })} className={selectCls}>
            <option value="deposito">Deposito Centrale</option>
            <option value="cantiere">Cantiere</option>
            <option value="ufficio">Ufficio</option>
          </select>
        </div>
        {value.ubicazione === "cantiere" && (
          <div>
            <Label>Cantiere</Label>
            <select data-testid="assoc-cantiere" value={value.cantiere_id} onChange={(e) => set({ cantiere_id: e.target.value })} className={selectCls}>
              <option value="">— scegli —</option>
              {cantieri.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};
